// Ursprungligen h�mtat fr�n https://jasonwatmore.com/post/2018/07/14/vue-vuex-user-registration-and-login-tutorial-example
// D�refter modifierat

export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token };
    } else {
        return {};
    }
}